<template>
  <div
    id="app"
    :style="{ backgroundColor: '#' + $store.state.backgroundColor + '80' }"
  >
    <spjz-navigation />

    <div class="container-fluid mt-2">
      <template v-if="showLogoutNotice">
        <div class="modal fade show logout-notice" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ $t("user.logoutNotice.header") }}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="logoutUser"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p v-html="$t('user.logoutNotice.text', [timer])" />
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="logoutUser"
                >
                  {{ $t("user.logoutNotice.logoutButton") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="refreshToken"
                >
                  {{ $t("user.logoutNotice.stayButton") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </template>
      <template v-if="$store.state.searchQuery">
        <spjz-search-results />
      </template>
      <template v-else>
        <router-view></router-view>
      </template>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import Navigation from "./components/Navigation";
import SearchResults from "./components/search/SearchResults";
import {
  FIREBASE_DB_URL,
  FIREBASE_AUTH_URL,
  FIREBASE_API_KEY
} from "./constants";

export default {
  name: "app",
  components: {
    "spjz-navigation": Navigation,
    "spjz-search-results": SearchResults
  },
  computed: {
    timer() {
      // Time calculations for minutes and seconds
      var minutes = Math.floor(this.$store.state.loginExpiresIn / (1000 * 60));
      var seconds = Math.floor(
        (this.$store.state.loginExpiresIn % (1000 * 60)) / 1000
      );
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    showLogoutNotice() {
      return (
        this.$store.getters.loggedUser &&
        this.$store.state.loginExpiresIn &&
        this.$store.state.loginExpiresIn / 1000 < 60
      );
    }
  },
  methods: {
    ...mapMutations(["logoutUser"]),
    ...mapActions(["refreshToken"])
  },
  beforeCreate() {
    // init vue-resources
    this.$store.state.resources = {
      users: this.$resource(
        FIREBASE_DB_URL + "/users{/userId}.json?auth={authToken}"
      ),
      pantries: this.$resource(
        FIREBASE_DB_URL + "/pantries{/pantryId}.json?auth={authToken}"
      ),
      categories: this.$resource(
        FIREBASE_DB_URL +
          "/pantries{/pantryId}/categories{/id}.json?auth={authToken}"
      ),
      food: this.$resource(
        FIREBASE_DB_URL + "/pantries{/pantryId}/food{/id}.json?auth={authToken}"
      ),
      auth: this.$resource(
        FIREBASE_AUTH_URL + ":{endpoint}?key=" + FIREBASE_API_KEY
      )
    };

    // this will check if user is logged (in localStorage) and if yes, fetch data for the user
    this.$store.dispatch("checkLoggedUser");
  }
};
</script>

<style lang="scss">
@import "./assets/scss/app";
.logout-notice {
  display: block;
}
</style>
